<template>
  <div class="w-100" :class="{
    'p-4': !is_mobile_view
  }">
    <div class="pb-4 mb-4 border-2-bottom-dashed">
      <div class="row">
        <div class="col-10" :class="is_mobile_view?'align-self-center':'align-self-end'">
          <p class="mb-0" :class="is_mobile_view?'body-1-4':'body-2-2 text-20 font-bold'">Payment option</p>
          <p class="mb-0" :class="is_mobile_view?'body-3-3-1':'body-2-2'">Customize your payment options</p>
        </div>
        <div class="col-2 text-right" :class="is_mobile_view?'align-self-center':'align-self-end'">
          <div class="d-table ml-auto no-ws" v-if="show_clear_button" @click="toggleSelectPayment()">
            <div class="d-inline-block align-middle mr-2">
              <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 0L10.5 1H14V3H0V1H3.5L4.5 0H9.5ZM1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM3 6H11V16H3V6Z" fill="#dc3545"/>
              </svg>
            </div>
            <p v-if="!is_mobile_view" class="d-inline-block align-middle mb-0 body-2 text-danger cursor-pointer">Clear Selection</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <template v-for="(pay,index) in payment.list">
        <div class="col-12 mb-3" v-if="pay.is_active">
          <div class="w-100 p-3 mb-3 payment-option-item rounded-6" :class="{'active':payment.selected.id && pay.id == payment.selected.id}">
            <div class="row no-gutters cursor-pointer" @click="toggleSelectPayment(pay)">
              <div :class="is_mobile_view?'col-11':'col-10'">
                <div class="row no-gutters">
                  <div class="col-1" v-if="getMerchant.use_changeable_deposit_value">
                    <div class="d-table" :class="{'ml-3 mt-1': !is_mobile_view}">
                      <div v-if="total_option_shown > 1">
                        <svg v-if="payment.selected.id && pay.id == payment.selected.id" width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.47998 0 0 4.47998 0 10C0 15.52 4.47998 20 10 20C15.52 20 20 15.52 20 10C20 4.47998 15.52 0 10 0ZM10 18C5.57996 18 2 14.42 2 10C2 5.58002 5.57996 2 10 2C14.42 2 18 5.58002 18 10C18 14.42 14.42 18 10 18ZM5 10C5 7.23859 7.23853 5 10 5C12.7615 5 15 7.23859 15 10C15 12.7614 12.7615 15 10 15C7.23853 15 5 12.7614 5 10Z" class="fill-primary"/>
                        </svg>
                        <svg v-else width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 10C0 4.47998 4.47998 0 10 0C15.52 0 20 4.47998 20 10C20 15.52 15.52 20 10 20C4.47998 20 0 15.52 0 10ZM2 10C2 14.42 5.57996 18 10 18C14.42 18 18 14.42 18 10C18 5.58002 14.42 2 10 2C5.57996 2 2 5.58002 2 10Z" fill="#ddd"/>
                        </svg>
                      </div>
                      <div v-else>
                        <svg v-if="payment.selected.id && pay.id == payment.selected.id" width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M16 0H2C0.900024 0 0 0.900024 0 2V16C0 17.1 0.900024 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.900024 17.1 0 16 0ZM16 16H2V2H16V16ZM13.58 4.58002L14.99 6L6.98999 14L2.98999 10.01L4.41003 8.60004L6.98999 11.17L13.58 4.58002Z" class="fill-primary"/>
                        </svg>
                        <svg v-else width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0H16C17.1 0 18 0.900024 18 2V16C18 17.1 17.1 18 16 18H2C0.900024 18 0 17.1 0 16V2C0 0.900024 0.900024 0 2 0ZM16 16V2H2V16H16Z" fill="#ddd"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div :class="getMerchant.use_changeable_deposit_value?'col-11':'col-12'">
                    <div class="w-100" :class="{'px-3': is_mobile_view}">
                      <p class="mb-0 sub-heading-1-2">{{ pay.name }}</p>
                      <p class="body-2-2 mb-0">{{ pay.description }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-right" :class="is_mobile_view?'col-1':'col-2'">
                <svg v-if="index == 0" width="36" height="44" viewBox="0 0 36 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M18 0L0 8V20C0 31.1 7.68 41.48 18 44C28.32 41.48 36 31.1 36 20V8L18 0ZM32 20C32 29.04 26.04 37.38 18 39.86C9.95996 37.38 3.99996 29.04 3.99996 20V10.6L18 4.37997L32 10.6V20ZM5.99999 24L8.81999 21.18L14 26.34L27.18 13.16L30 16L14 32L5.99999 24Z" class="fill-secondary" :fill-opacity="payment.selected.id && pay.id == payment.selected.id ? '1' : '0.3'"/>
                </svg>
                <svg v-else width="40" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M36 0H4C1.78 0 0.02 1.78 0.02 4L0 28C0 30.22 1.78 32 4 32H36C38.22 32 40 30.22 40 28V4C40 1.78 38.22 0 36 0ZM36 28H4V16H36V28ZM4 8H36V4H4V8Z" class="fill-secondary" :fill-opacity="payment.selected.id && pay.id == payment.selected.id ? '1' : '0.3'"/>
                </svg>
              </div>
            </div>

            <!-- CC INPUT -->
            <template v-if="pay.id == 'cc_guarantee' && payment.selected.id && pay.id == payment.selected.id">
              <div class="w-100 mt-3 border-2-bottom-dashed my-4"></div>
              <div class="w-100 p-4 border radius-6" :class="cc.is_done?'bg-white':'bg-light-desktop'">
                <div class="row no-gutters mb-4">
                  <div class="col-8">
                    <p class="mb-0 sub-heading-1-2">Credit Card Guarantee</p>
                    <p class="body-2-2 mb-0">To complete your reservation, please complete your credit card data for guarantee</p>
                  </div>
                  <div class="col-4 text-right">
                    <img class="d-inline-block align-middle" width="55" v-for="img_cc in cc.img_list" :src="img_cc">
                  </div>
                </div>
                <div class="row no-gutters mb-3">
                  <div class="mb-3" :class="is_mobile_view?'col-12':'col-9 '">
                    <div class="w-100" :class="{'pr-2':!is_mobile_view}">
                      <label for="card_number" class="body-2-1 cc-form-label" :class="cc.active_class.card_number?'active':''">Card Number</label>
                      <div class="w-100 py-3 border-semi-grey box-shadow-light-aff rounded-10 position-relative cc-form-wrapper pr-3" :class="{'active':cc.active_class.card_number,'border-danger':showFormCCError('card_number'),'bg-light-desktop':cc.is_done,'bg-white':!cc.is_done}" style="padding-left: 50px;">
                        <div :key="cc.card_type_key" class="position-absolute px-2" style="width: 50px;top: 13px;left: 0px;">
                          <img :src="cc.card_type.image_url" class="w-100">
                        </div>
                        <input
                          :disabled="cc.is_done"
                          @focus="toggleClassForm('card_number')"
                          @blur="toggleClassForm('card_number')"
                          type="text"
                          v-model="cc.form.card_number"
                          class="ls-1-5 border-none no-focus-border body-1-2 w-100 bg-transparent"
                          data-inputmask="'mask': '9999 9999 9999 9999'"
                          placeholder="0000 0000 0000 0000"
                        />
                      </div>
                      <p class="mb-0 text-danger body-2 text-12 font-regular delay mt-1" v-if="showFormCCError('card_number')">{{cc.error.card_number}}</p>
                    </div>
                  </div>
                  <!-- FOR DESKTOP -->
                  <div v-if="!is_mobile_view" class="mb-3" :class="is_mobile_view?'col-12':'col-3'">
                    <div class="w-100" :class="{'pl-2':!is_mobile_view}">
                      <label for="card_number" class="body-2-1 cc-form-label" :class="cc.active_class.cvv?'active':''">CVV</label>
                      <div class="w-100 py-3 border-semi-grey box-shadow-light-aff rounded-10 position-relative cc-form-wrapper pr-3" :class="{'active':cc.active_class.cvv,'border-danger':showFormCCError('cvv'),'bg-light-desktop':cc.is_done,'bg-white':!cc.is_done}" style="padding-left: 50px;">
                        <div :key="cc.card_type_key" class="position-absolute px-2 text-center" style="width: 50px;top: 15px;left: 0px;">
                          <i class="simple-icon-key text-20"></i>
                        </div>
                        <input 
                          :disabled="cc.is_done"
                          type="password" 
                          v-model="cc.form.cvv"
                          maxlength="4"
                          class="ls-1-5 border-none no-focus-border body-1-2 w-100 bg-transparent"
                          placeholder="***" 
                          @focus="toggleClassForm('cvv')"
                          @blur="toggleClassForm('cvv')"
                          @input="validateFormCopas('cvv')"
                          />
                      </div>
                      <p class="mb-0 text-danger body-2 text-12 font-regular delay mt-1" v-if="showFormCCError('cvv')">{{cc.error.cvv}}</p>
                    </div>
                  </div>
                  <!-- END FOR DESKTOP -->
                  <div :class="is_mobile_view?'col-12 mb-3':'col-9 mb-2'">
                    <div class="w-100" :class="{'pr-2':!is_mobile_view}">
                      <label for="card_number" class="body-2-1 cc-form-label" :class="cc.active_class.card_holder?'active':''">Name on Card</label>
                      <div class="w-100 py-3 border-semi-grey box-shadow-light-aff rounded-10 position-relative cc-form-wrapper pr-3" :class="{'active':cc.active_class.card_holder,'border-danger':showFormCCError('card_holder'),'bg-light-desktop':cc.is_done,'bg-white':!cc.is_done}" style="padding-left: 50px;">
                        <div :key="cc.card_type_key" class="position-absolute px-2 text-center" style="width: 50px;top: 15px;left: 0px;">
                          <i class="simple-icon-user text-20"></i>
                        </div>
                        <input
                          :disabled="cc.is_done"
                          @focus="toggleClassForm('card_holder')"
                          @blur="toggleClassForm('card_holder')"
                          type="text"
                          v-model="cc.form.card_holder"
                          class="ls-1-5 border-none no-focus-border body-1-2 w-100 bg-transparent"
                          placeholder="e.g. Ragil Samsi"
                        />
                      </div>
                      <p class="mb-0 text-danger body-2 text-12 font-regular delay mt-1" v-if="showFormCCError('card_holder')">{{cc.error.card_holder}}</p>
                    </div>
                  </div>

                  <div class="mb-2" :class="is_mobile_view?'col-12':'col-3'">
                    <div class="w-100" :class="!is_mobile_view?'pl-2':''">
                      <label for="card_number" class="body-2-1 cc-form-label" :class="cc.active_class.exp_date?'active':''">Expiry Date</label>
                      <div class="w-100 py-3 border-semi-grey box-shadow-light-aff rounded-10 position-relative cc-form-wrapper pr-3" :class="{'active':cc.active_class.exp_date,'border-danger':showFormCCError('exp_date'),'bg-light-desktop':cc.is_done,'bg-white':!cc.is_done}" style="padding-left: 50px;">
                        <div :key="cc.card_type_key" class="position-absolute px-2 text-center" style="width: 50px;top: 15px;left: 0px;">
                          <i class="simple-icon-calendar text-20"></i>
                        </div>
                        <input 
                          :disabled="cc.is_done"
                          type="text" 
                          v-model="cc.form.exp_date"
                          class="ls-1-5 border-none no-focus-border body-1-2 w-100 bg-transparent"
                          data-inputmask="'mask': '99/9999'"
                          placeholder="MM/YYYY" 
                          @focus="toggleClassForm('exp_date')"
                          @blur="toggleClassForm('exp_date')"
                          />
                      </div>
                      <p class="mb-0 text-danger body-2 text-12 font-regular delay mt-1" v-if="showFormCCError('exp_date')">{{cc.error.exp_date}}</p>
                    </div>
                  </div>

                  <!-- FOR MOBILE -->
                  <div v-if="is_mobile_view" class="mb-3 col-12">
                    <div class="w-100 pr-2">
                      <label for="card_number" class="body-2-1 cc-form-label" :class="cc.active_class.cvv?'active':''">CVV</label>
                      <div class="w-100 py-3 border-semi-grey box-shadow-light-aff rounded-10 position-relative cc-form-wrapper pr-3" :class="{'active':cc.active_class.cvv,'border-danger':showFormCCError('cvv'),'bg-light-desktop':cc.is_done,'bg-white':!cc.is_done}" style="padding-left: 50px;">
                        <div :key="cc.card_type_key" class="position-absolute px-2 text-center" style="width: 50px;top: 15px;left: 0px;">
                          <i class="simple-icon-lock text-20"></i>
                        </div>
                        <input 
                          :disabled="cc.is_done"
                          type="password" 
                          v-model="cc.form.cvv"
                          maxlength="4"
                          class="ls-1-5 border-none no-focus-border body-1-2 w-100 bg-transparent"
                          placeholder="***" 
                          @focus="toggleClassForm('cvv')"
                          @blur="toggleClassForm('cvv')"
                          @input="validateFormCopas('cvv')"
                          />
                      </div>
                      <p class="mb-0 text-danger body-2 text-12 font-regular delay mt-1" v-if="showFormCCError('cvv')">{{cc.error.cvv}}</p>
                    </div>
                  </div>
                  <!-- END MOBILE -->
                </div>
                <div class="w-100">
                  <div class="d-inline-block align-top mr-2">
                    <i class="simple-icon-lock text-16"></i>
                  </div>
                  <p class="w-80 mb-0 body-2-2-1 d-inline-block align-top">Your transaction is secured with <span class="font-bold text-green cursor-pointer" @click="openCertif">Channex PCI Compliance</span></p>
                </div>
                <div v-if="cc.error_push != ''" class="w-100 mt-3">
                  <ErrorMessage :message="cc.error_push"></ErrorMessage>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script type="text/javascript">
  import Inputmask from "inputmask";
	import 'inputmask/dist/inputmask.min.js';
	import 'inputmask/dist/bindings/inputmask.binding.js';
  import { mapGetters } from 'vuex';
  import moment from "moment";
  import config from '@/config/index.js';
  import {post,get} from '@/services/index.js'
  import cc_mastercard from '@/assets/img/icon/payment/cc/Mastercard.png'
  import cc_visa from '@/assets/img/icon/payment/cc/Visa.png'
  import cc_jcb from '@/assets/img/icon/payment/cc/JCB.png'
  import cc_amex from '@/assets/img/icon/payment/cc/Amex.png'
  import cc_discover from '@/assets/img/icon/payment/cc/Discover.png'
  import cc_default from '@/assets/img/icon/payment/cc/Default.png'
  
  export default {
    data() {
      return {
        payment:{
          list: [
            {id: 'cc_guarantee', is_active: true, name: 'Pay at Hotel', description: 'To complete your reservation, you need to provide your credit card details that will be transferred to the hotel to guarantee your reservation (Credit Card Guarantee).'},
            {id: 'pay_deposit', is_active: true, name: 'Pay Deposit Now', description: ''},
          ],
          selected: {}
        },
        cc:{
          form:{
            card_number: '',
            exp_date: '',
            cvv: '',
            card_holder: ''
          },
          active_class:{
            card_number: false,
            exp_date: false,
            cvv: false,
            card_holder: false
          },
          error:{
            card_number: 'start',
            exp_date: 'start',
            cvv: 'start',
            card_holder: 'start'
          },
          error_push: '',
          img_list: [cc_mastercard,cc_visa,cc_jcb,cc_amex,cc_discover],
          card_type: {},
          card_type_key: 0,
          is_done: false
        },
        window_width: window.innerWidth
      }
    },
    computed: {
      ...mapGetters(['getMerchant','getBeFilter','getCurrentLanguage','getBeCartRoom']),
      total_option_shown(){
        return this.payment.list.filter(x=>x.is_active).length 
      },
      show_clear_button(){        
        if(this.total_option_shown < 2){
          return false
        }else{
          return this.payment.selected.id ? true : false
        }
      },
      card_number(){
        return this.cc.form.card_number
      },
      is_mobile_view(){
        return this.window_width > 768 ? false : true
      }
    },
    watch:{
      card_number(){
        this.CcIdentifying()
      }
    },
    created(){
      this.CcIdentifying()
    },
    mounted(){
      this.loadFirstData()
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResizeWindow);
      })
    },
    beforeDestroy() { 
      window.removeEventListener('resize', this.onResizeWindow); 
    },
    methods: {
      onResizeWindow(){
        this.window_width = window.innerWidth
      },
      loadFirstData() {
        let externalScript = document.createElement('script')
        externalScript.setAttribute('src', config.XENDIT_URL)
        document.head.appendChild(externalScript)

        this.payment.list[0].is_active = this.getMerchant.deposit_zero_use_cc_guarantee
        if(this.getMerchant.deposit_zero_use_cc_guarantee && !this.getMerchant.use_changeable_deposit_value){
          this.setupCardNumberInput()
          this.payment.selected = this.payment.list[0]
          this.$emit('submitPaymentOption', this.payment.selected)
        }
        this.payment.list[1].is_active = this.getMerchant.use_changeable_deposit_value
        this.payment.list[1].description = `Complete your order by paying a deposit of ${this.getMerchant.deposit_zero_minimum_deposit_value}% of your total order. You can choose several payment methods in the next step`
      },
      toggleClassForm(field){
        this.cc.active_class[field] = !this.cc.active_class[field]
        if(!this.cc.active_class[field]){
          this.validateFormCC(field)
        }
      },
      validateFormCopas(field){
				this.cc.form[field] = this.cc.form[field].replace(/\D/g,'')
			},
      CcIdentifying(){
        let cc_list = [
          {id: 'mastercard', image_url: cc_mastercard, regex: /^5[1-5][0-9]{5,}$/},
          {id: 'visa', image_url: cc_visa, regex: /^4[0-9]{6,}$/},
          {id: 'jcb', image_url: cc_jcb, regex: /^(?:2131|2100|1800|35\d{3})\d{11}$/},
          {id: 'amex', image_url: cc_amex, regex: /^3[47][0-9]{5,}$/},
          {id: 'discover', image_url: cc_discover, regex: /^6(?:011|5[0-9]{2})[0-9]{3,}$/},
          {id: 'default', image_url: cc_default, regex: /.*/}
        ]
        if(this.cc.form.card_number != ''){
          for (let i = 0; i < cc_list.length; i++) {
            const element = cc_list[i];
            let cn = this.cc.form.card_number.replace(/\D/g,'')
            if(element.regex.test(cn)){
              this.cc.card_type = element
              this.cc.card_type_key++
              return;
            }
          }
        }else{
          this.cc.card_type = cc_list[5]
          this.cc.card_type_key++
        }
      },
      setupCardNumberInput(){
        setTimeout(()=>{
          $(document).ready(function(){
            Inputmask().mask(document.querySelectorAll("input"));
          });
        },100)
      },
      toggleSelectPayment(pay={}){
        if(this.total_option_shown > 1){
          this.payment.selected = pay
          this.setupCardNumberInput()
        }else{
          this.payment.selected = this.payment.selected.id ? {} : pay 
          if(this.payment.selected.id){
            this.setupCardNumberInput()
          }
        }
        this.$emit('submitPaymentOption', this.payment.selected)
      },
      validateFormCC(field=''){
        return new Promise((success,fail)=>{
          if(field == ''){
            this.cc.error = {
              card_number: 'start',
              exp_date: 'start',
              cvv: 'start',
              card_holder: 'start'
            }
          }else{
            this.cc.error[field] = 'start'
          }
          
          if(field == 'card_number' || field == ''){
            if(this.cc.form.card_number == ''){
              this.cc.error.card_number = 'Card number is required'
            }else{
              let cn = this.cc.form.card_number.replace(/\D/g,'')
              if(cn.length < 15){
                this.cc.error.card_number = 'Card number cannot be less than 15 characters'
              }else if(!Xendit.card.validateCardNumber(cn)){
                this.cc.error.card_number = 'Invalid card number'
              }else{
                this.cc.error.card_number = 'done'
              }
            }
          }else if(field === 'cvv' || field == ''){
              // CVV
              if(this.cc.form.cvv == ''){
              this.cc.error.cvv = 'CVV is required'
            }else if(this.cc.form.cvv.length < 3){
              this.cc.error.cvv = 'Invalid CVV'
            }else{
              if(Xendit.card.validateCvn(this.cc.form.cvv)){
                this.cc.error.cvv = 'done'
              }else{
                this.cc.error.cvv = 'Invalid CVV'
              }
            }
          }else if(field == 'card_holder' || field == ''){
            // NAME ON CARD
            if(this.cc.form.card_holder == ''){
              this.cc.error.card_holder = 'Name on Card'
            }else{
              this.cc.error.card_holder = 'done'
            }
          }else if(field == 'exp_date' || field == ''){
            // EXP DATE
            if(this.cc.form.exp_date == ''){
              this.cc.error.exp_date = 'Expiry date is required'
            }else {
              let ed = this.cc.form.exp_date.replace(/\D/g,'')
              if(ed.length < 6){
                this.cc.error.exp_date = 'Invalid expiry date'
              }else{
                let ed_s = this.cc.form.exp_date.split("/")
                if(Xendit.card.validateExpiry(ed_s[0],ed_s[1])){
                  this.cc.error.exp_date = 'done'
                }else{
                  this.cc.error.exp_date = 'Invalid expiry date'
                }
              }
            }
          }

          if(
              this.cc.error.card_number === 'done' && 
              this.cc.error.exp_date === 'done' &&
              this.cc.error.cvv === 'done' && 
              this.cc.error.card_holder === 'done'){
              this.$emit('changeStatusCC',true)
            success()
          }else{
            this.$emit('changeStatusCC',false)
            if(field != ''){
              success()
            }else{
              fail()
            }
          }
        })
      },
      showFormCCError(field){
        return !(this.cc.error[field] == 'start' || this.cc.error[field] == 'done')
      },
      getRoomList(){
        return new Promise(done=>{
          let params = { 
            merchant_id: this.getMerchant.id,
            check_in_date: moment(this.getBeFilter.date.check_in).format("YYYY-MM-DD"),
            check_out_date: moment(this.getBeFilter.date.check_out).format("YYYY-MM-DD"),
            adult: this.getBeFilter.guest.adult,
            child: this.getBeFilter.guest.child,
            infant: this.getBeFilter.guest.infant,
            sort_by: 'room_type',
            price_min: '',
            price_max: '',
            language_code: this.getCurrentLanguage,
            device: 'DESKTOP',
            use_promotion_combine:true,
            promo_code: this.getBeFilter.promo_code
          }

          get("CORE_HOTEL", "search-room", params).then(response => {
            let res = response.data
            if (res.success) {
              done(res.room_type_availability)
            }else{
              done(res.message)
            }
          })

        })
      },
      checkAvailabilityRoom(){
        return new Promise((success,fail)=>{
          this.getRoomList().then(response=>{
            let room_type_vuex = []

            
            for (let i = 0; i < this.getBeCartRoom.length; i++) {
              const room_vuex = this.getBeCartRoom[i]
              let is_rt_added = room_type_vuex.findIndex(rt=>rt.id==room_vuex.room_rate.room_type.id)
              if(is_rt_added == -1){
                let item = {
                  id: room_vuex.room_rate.room_type.id,
                  qty: room_vuex.qty
                }
                room_type_vuex.push(item)
              }else{
                room_type_vuex[is_rt_added].qty += room_vuex.qty
              }

              if((i+1) == this.getBeCartRoom.length){
                for (let y = 0; y < room_type_vuex.length; y++) {
                  const room_vuex_qty = room_type_vuex[y];
                  let is_room_type_matched = response.findIndex(room_avlb=>room_avlb.id == room_vuex_qty.id)
                  if(is_room_type_matched != -1){
                    if(response[is_room_type_matched].availability < room_vuex_qty.qty){
                      fail('room-not-available')
                    }              
                    if((y+1) == room_type_vuex.length){
                      success()
                    }
                  }else{
                    fail('room-not-available')
                  }
                }
              }
            }
          }).catch(err=> fail(err))
        })
      },
      submitCC(){
        return new Promise((success,fail)=>{
          this.checkAvailabilityRoom().then(()=>{
            this.cc.error_push = ''
            let ed_s = this.cc.form.exp_date.split("/")
            let params = {
              merchant_id: this.getMerchant.id,
              card_number: this.cc.form.card_number.replace(/\D/g,''),
              cardholder_name: this.cc.form.card_holder,
              cvn_code: this.cc.form.cvv,
              month: ed_s[0],
              year: ed_s[1]
            }

            post("BASE","channex-pci/direct-save-card",params).then(response=>{
              let res = response.data
              if(res.success){
                this.cc.is_done = true
                this.$emit('getCreditCardId',res.data.id)
                success()
              }else{
                this.$emit('getCreditCardId','error')
                this.cc.error_push = res.message
                fail()
              }
            })
          }).catch(err=>{
            if(err == 'room-not-available'){
              fail('room-not-available')
            }else{
              this.$emit('getCreditCardId','error')
              this.cc.error_push = `Error while checking room availabilty, Please try again. ${err}`
              fail('')
            }
          })
        })
      },
      EditCC(){
        return new Promise((success,fail)=>{
          this.cc.is_done = false
          this.$emit('changeStatusCC',this.cc.is_done)
        })
      },
      openCertif(){
        let channex_pci_dss_url = 'https://channex.io/pci-certification'
        window.open(channex_pci_dss_url,'_blank')
      }
    },
  }
</script>
<style>
  .payment-option-item{
    transition: 0.1s;
    border: 2px solid #DDD;
  }
  .payment-option-item:hover{
    border-color: var(--merchant-primary-color);
  }
  .payment-option-item.active{
    border-color: var(--merchant-primary-color);
  }
  path.fill-secondary{
    fill:var(--merchant-button-color)!important;
  }
  .cc-form-wrapper.active{
    border-color: var(--merchant-primary-color) !important;
  }
  .cc-form-label.active{
    color: var(--merchant-primary-color) !important;
  }
  .bg-transparent{
    background-color: transparent !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/PaymentOption.vue